import dayjs from "dayjs"
import dateFnsFormat from "date-fns/format";
import dateFnsParse from "date-fns/parse";

import { DAY_OF_WEEK } from '@/const/Constants';


export class DateUtil {

    /**
     * 日付が一致するか判断します
     * @param date1
     * @param date2
     * @param unit
     * @returns
     */
    public static isSame(
        date1: Date | string | undefined,
        date2: Date | string | undefined,
        unit: dayjs.OpUnitType | null = 'date'
    ): boolean {
        const d1 = dayjs(date1)
        const d2 = dayjs(date2)
        return d1.isSame(d2, (unit) ? unit : undefined)
    }

    /**
     * date1がdate2以降か判断します
     * @param date1
     * @param date2
     * @param unit
     * @returns
     */
    public static isAfter(
        date1: Date | string | undefined,
        date2: Date | string | undefined,
        unit: dayjs.OpUnitType | null = 'date'
    ): boolean {
        const d1 = dayjs(date1)
        const d2 = dayjs(date2)
        return d1.isAfter(d2, (unit) ? unit : undefined)
    }

    /**
     * date1がdate2以前か判断します
     * @param date1
     * @param date2
     * @param unit
     * @returns
     */
    public static isBefore(
        date1: Date | string | undefined,
        date2: Date | string | undefined,
        unit: dayjs.OpUnitType | null = 'date'
    ): boolean {
        const d1 = dayjs(date1)
        const d2 = dayjs(date2)
        return d1.isBefore(d2, (unit) ? unit : undefined)
    }

    /**
     * date1がdate2と一致もしくは以後か判断します
     * @param date1
     * @param date2
     * @param unit
     * @returns
     */
    public static isSameOrAfter(
        date1: Date | string | undefined,
        date2: Date | string | undefined,
        unit: dayjs.OpUnitType | null = 'date'
    ): boolean {
        return this.isSame(date1, date2, unit) || this.isAfter(date1, date2, unit)
    }

    /**
     * date1がdate2と一致もしくは以前か判断します
     * @param date1
     * @param date2
     * @param unit
     * @returns
     */
    public static isSameOrBefore(
        date1: Date | string | undefined,
        date2: Date | string | undefined,
        unit: dayjs.OpUnitType | null = 'date'
    ): boolean {
        return this.isSame(date1, date2, unit) || this.isBefore(date1, date2, unit)
    }

    public static parseYMD(date: Date | string | undefined) {
        const d = dayjs(date)
        return [
            d.format('YYYY'),
            d.format('MM'),
            d.format('DD')
        ]
    }

    public static format(date: Date | string | undefined, format: string = 'YYYY/MM/DD') {
        return dayjs(date).format(format)
    }

    public static formatFullDateTime(date: Date | string | undefined, format: string = 'YYYY/MM/DD HH:mm:ss') {
        return dayjs(date).format(format)
    }

    public static timeToDate(time: string) {
        const nowYMD = dayjs().format('YYYY/MM/DD')
        return dayjs(nowYMD + ' ' + time).toDate()
    }
    /**
     * 引数で渡した日を含む月の月初日を返却します
     * @param day 
     * @returns 
     */
    public static getFirstDayOfMonth(day: Date) {
        const processdDay = dayjs(day.toString());
        return processdDay.set('date', 1).toDate();
    }

    /**
     * 引数で渡した日を含む月の月末日を返却します
     * @param day 
     * @returns 
     */
    public static getEndDayOfMonth(day: Date) {
        let processdDay = dayjs(day.toString())
        processdDay = processdDay.add(1, 'month')
        processdDay = processdDay.set('date', 0)
        return processdDay.toDate()
    }

    /**
     * 引数で渡した日時における時間部分を全て0にして返却します
     * @param datetime 
     * @returns 
     */
    public static setZeroForTime(datetime: Date){ 
        datetime.setHours(0)
        datetime.setMinutes(0)
        datetime.setSeconds(0)
        datetime.setMilliseconds(0)
        return datetime
    }

    public static splitTimeString(timeString: string){
      if(!timeString){
        return null
      }

      const splittedTimeString = timeString.split(':')

      return {
        hour: splittedTimeString[0],
        minutes: splittedTimeString[1],
        second: splittedTimeString[2]
      }
    }

    /**
   * momentのisValidの代替（未検証）
   * https://zenn.dev/hooyan/articles/c11a9171b60a89
   * @param str
   * @param format
   * @param refarenceDate
   * @returns
   */
    static isValidDateString(str: string, format: string, refarenceDate: number) {
        const formatString = dateFnsFormat(
            dateFnsParse(str, format, refarenceDate),
            format
        )
        return formatString === str;
    }

    public static isSameTime(time1: string | null, time2: string | null) {
        if(!time1 || !time2){
            return false
        }
        const nowYMD = dayjs().format('YYYY/MM/DD')
        const d1 = dayjs(nowYMD + ' ' + time1)
        const d2 = dayjs(nowYMD + ' ' + time2)
        return d1.isSame(d2)
    }
}
